import { lazy } from "react";
import IntlTranslation from "./intlTranslation.js";
import authorityAlls from "@/utils/authorityAlls.js";
import IconFontSider from '@/components/iconSider/index'
const {
	ADVERTISING_RETAIL_READ,
	ADVERTISING_RETAIL_WRITE,
	ADVERTISING_RETAIL_APPROVAL_READ,
	ADVERTISING_RETAIL_APPROVAL_WRITE,
	ANALYZER_RETAIL_READ,
	ANALYZER_RETAIL_WRITE,
	PRODUCT_RETAIL_READ,
	PRODUCT_RETAIL_WRITE,
	GOODS_PROFESSIONAL_WRITE,
	GOODS_PROFESSIONAL_READ,
	SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ,
	SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE,
	COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ,
	COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE,
	HEALTHY_HAIR_RETAIL_READ,
	HEALTHY_HAIR_RETAIL_WRITE,
	HEALTHY_HAIR_PROFESSIONAL_READ,
	HEALTHY_HAIR_PROFESSIONAL_WRITE,
	ROLE_READ,
	ROLE_WRITE,
	AUTHORITY_READ,
	AUTHORITY_WRITE,
	USER_READ,
	USER_WRITE,
	ANALYZER_PROFESSIONAL_READ,
	ANALYZER_PROFESSIONAL_WRITE,
	ADVERTISING_APPROVAL_PROFESSIONAL_READ,
	ADVERTISING_APPROVAL_PROFESSIONAL_WRITE,
	ADVERTISING_PROFESSIONAL_READ,
	ADVERTISING_PROFESSIONAL_WRITE,
	CUSTOMERS_PROFESSIONAL_WRITE,
	CUSTOMERS_PROFESSIONAL_READ,
	COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_WRITE,
	COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_READ,
	STORE_WRITE,
	STORE_READ,
	CUSTOMER_WRITE,
	CUSTOMER_READ,
	SUMMARY_STATISTICS
} = authorityAlls;
const Login = lazy(() => import("@/pages/login/index.js"));
const NotFound = lazy(() => import("@/pages/notFound/index.js"));
const Layout = lazy(() => import("@/components/layout/index.js"));
const Advertisement = lazy(() => import("@/pages/advertisement/index"));
const ProfessionalAdvertisement = lazy(() => import("@/pages/advertisement/professionalAdvertisement/index"));
const RetailAdvertisement = lazy(() => import("@/pages/advertisement/retailAdvertisement/index"));
const Review = lazy(() => import("@/pages/review/index"));
const Device = lazy(() => import("@/pages/device/index"));
const Shops = lazy(() => import('@/pages/shops/index'))
const Recommend = lazy(() => import("@/pages/recommend/index"));
const Comprehensive = lazy(() => import("@/pages/recommend/comprehensive/index"));
const Single = lazy(() => import('@/pages/recommend/single/index'))
const ComprehensiveAll = lazy(() => import('@/pages/recommend/components/comprehensiveAll/index'))
const Product = lazy(() => import("@/pages/product/index"));
const ProductProfessional = lazy(() => import("@/pages/product/professional/index"));
const ProductRetail = lazy(() => import("@/pages/product/retail/index"));
const ProductDetail = lazy(() => import("@/pages/product/components/productDetail/index"));
const Contract = lazy(() => import("@/pages/contract/index"));
const ContractProfessional = lazy(() => import("@/pages/contract/professional/index"));
const ContractRetail = lazy(() => import("@/pages/contract/retail/index"));
const Role = lazy(() => import("@/pages/role/index"));
const User = lazy(() => import("@/pages/user/index"));
const Authority = lazy(() => import("@/pages/authority/index"));
const Unaudited = lazy(() => import("@/pages/review/unaudited/index"));
const Audited = lazy(() => import("@/pages/review/audited/index"));
const Submitted = lazy(() => import("@/pages/review/submitted/index"));
const Cookies = lazy(() => import("@/pages/cookies/index.js"));
const Protection = lazy(() => import("@/pages/protection/index.js"));
const TermsUsage = lazy(() => import("@/pages/termsusage/index.js"));
const CopyrightNotice = lazy(() => import("@/pages/copyrightnotice/index.js"));
const ProfessionalDevice = lazy(() => import("@/pages/device/professionalDevice/index"));
const ShopsItem = lazy(() => import('@/pages/shops/shopsItem/index.js'))
const ShopsConsumer = lazy(() => import('@/pages/shops/shopsConsumer/index.js'))
const RetailDevice = lazy(() => import("@/pages/device/retailDevice/index"));
const ReviewProfessional = lazy(() => import("@/pages/reviewProfessional/index"));
const UnauditedProfessional = lazy(() => import("@/pages/reviewProfessional/unaudited/index"));
const AuditedProfessional = lazy(() => import("@/pages/reviewProfessional/audited/index"));
const SubmittedProfessional = lazy(() => import("@/pages/reviewProfessional/submitted/index"));
const Customers = lazy(() => import("@/pages/customers/index"));
const Dashboard = lazy(() => import('@/pages/dashboard/index'))
const routes = [
	{
		path: "/login",
		component: Login,
		title: "登录页面",
	},
	{
		path: "/cookies",
		component: Cookies,
	},
	{
		path: "/protection",
		component: Protection,
	},
	{
		path: "/termsUsage",
		component: TermsUsage,
	},
	{
		path: "/copyrightNotice",
		component: CopyrightNotice,
	},

	{
		path: "/layout",
		component: Layout,
		routes: [
			{
				path: "/layout/dashboard",
				component: Dashboard,
				icon: <IconFontSider type="icon-data" />,
				title: '数据看板',
				authority: [SUMMARY_STATISTICS],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
			},
			{
				path: "/layout/stores",
				component: Shops,
				icon: <IconFontSider type="icon-store" />,
				title: '店铺管理',
				authority: [STORE_WRITE, STORE_READ, CUSTOMER_WRITE, CUSTOMER_READ],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
				routes: [
					{
						path: "/layout/stores/index",
						component: ShopsItem,
						title: <IntlTranslation intlkey="shops" />,
						authority: [STORE_WRITE, STORE_READ],
					},
					{
						path: "/layout/stores/consumer",
						component: ShopsConsumer,
						title: <IntlTranslation intlkey="consumer" />,
						authority: [CUSTOMER_WRITE, CUSTOMER_READ],
					},
				],
			},
			{
				path: "/layout/device",
				component: Device,
				icon: <IconFontSider type="icon-device" />,
				title: '设备管理',
				authority: [ANALYZER_RETAIL_READ, ANALYZER_RETAIL_WRITE, ANALYZER_PROFESSIONAL_READ, ANALYZER_PROFESSIONAL_WRITE],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
				routes: [
					{
						path: "/layout/device/professional",
						component: ProfessionalDevice,
						title: <IntlTranslation intlkey="professional" />,
						authority: [ANALYZER_PROFESSIONAL_READ, ANALYZER_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/device/retail",
						component: RetailDevice,
						title: <IntlTranslation intlkey="retail" />,
						authority: [ANALYZER_RETAIL_READ, ANALYZER_RETAIL_WRITE],
					},
				],
			},
			{
				path: "/layout/goods/recommend",
				component: Recommend,
				isShowRoutes: false,
				isChargeProfessional: true,
				title: '产品推荐',
				authority: [COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ, COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE],
				routes: [
					{
						path: "/layout/goods/recommend/comprehensive",
						component: Comprehensive,
						title: '综合检测',
						authority: [COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ, COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE],
					},
					{
						path: "/layout/goods/recommend/single",
						component: Single,
						title: '单项检测',
						authority: [COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ, COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE],
					},
					{
						path: "/layout/goods/recommend/comprehensiveAll",
						component: ComprehensiveAll,
						title: '综合检测产品推荐',
						authority: [COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_WRITE, COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_READ],
					},
				],
			},
			{
				path: "/layout/goods/product",
				component: Product,
				isChargeProfessional: true,
				title: <IntlTranslation intlkey="product" />,
				authority: [PRODUCT_RETAIL_READ, PRODUCT_RETAIL_WRITE, GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
				routes: [
					{
						path: "/layout/goods/product/professional",
						component: ProductProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/goods/product/retail",
						component: ProductRetail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [PRODUCT_RETAIL_READ, PRODUCT_RETAIL_WRITE],
					},
					{
						path: "/layout/goods/product/detail",
						component: ProductDetail,
						title: <IntlTranslation intlkey="ProductDetail" />,
						authority: [PRODUCT_RETAIL_WRITE],
					},
				],
			},
			{
				path: "/layout/goods",
				title: '产品管理',
				isOne: true,
				icon: <IconFontSider type="icon-product" />,
				isShowRoutes: true,
				authority: [
					// SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ,
					// SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE,
					COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ,
					COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE,
					PRODUCT_RETAIL_READ,
					PRODUCT_RETAIL_WRITE
				],
				routes: [
					{
						path: "/layout/goods/product",
						component: Product,
						isChargeProfessional: true,
						title: '产品列表',
						authority: [PRODUCT_RETAIL_READ, PRODUCT_RETAIL_WRITE, GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
						routes: [
							{
								path: "/layout/goods/product/professional",
								component: ProductProfessional,
								title: <IntlTranslation intlkey="professional" />,
								authority: [GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
							},
							{
								path: "/layout/goods/product/retail",
								component: ProductRetail,
								title: <IntlTranslation intlkey="retail" />,
								authority: [PRODUCT_RETAIL_READ, PRODUCT_RETAIL_WRITE],
							},
							{
								path: "/layout/goods/product/detail",
								component: ProductDetail,
								title: <IntlTranslation intlkey="ProductDetail" />,
							},
						],
					},
					{
						path: "/layout/goods/recommend",
						component: Recommend,
						isShowRoutes: false,
						isChargeProfessional: true,
						title: '产品推荐',
						authority: [COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ, COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE,
							// SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ, SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE
						],
						routes: [
							{
								path: "/layout/goods/recommend/comprehensive",
								component: Comprehensive,
								title: '综合检测',
								authority: [COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ, COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE],
							},
							{
								path: "/layout/goods/recommend/single",
								component: Single,
								title: '单项检测',
								authority: [SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ, SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE],
							},
							{
								path: "/layout/goods/recommend/comprehensiveAll",
								component: ComprehensiveAll,
								title: '综合检测产品推荐',
								authority: [COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_WRITE, COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_READ],
							},
						],
					},
				],
			},
			{
				path: "/layout/contract",
				component: Contract,
				isChargeProfessional: true,
				isOne: true,
				isShowRoutes: false,
				icon: <IconFontSider type="icon-comparison" />,
				title: '对比图管理',
				authority: [HEALTHY_HAIR_RETAIL_READ, HEALTHY_HAIR_RETAIL_WRITE, HEALTHY_HAIR_PROFESSIONAL_WRITE, HEALTHY_HAIR_PROFESSIONAL_READ],
				routes: [
					{
						path: "/layout/contract/professional",
						component: ContractProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [HEALTHY_HAIR_PROFESSIONAL_READ, HEALTHY_HAIR_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/contract/retail",
						component: ContractRetail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [HEALTHY_HAIR_RETAIL_READ, HEALTHY_HAIR_RETAIL_WRITE],
					},
				],
			},
			{
				path: "/layout/advertisement",
				component: Advertisement,
				icon: <IconFontSider type="icon-AD" />,
				title: '广告管理',
				authority: [ADVERTISING_RETAIL_READ, ADVERTISING_RETAIL_WRITE, ADVERTISING_PROFESSIONAL_WRITE, ADVERTISING_PROFESSIONAL_READ],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
				routes: [
					{
						path: "/layout/advertisement/professional",
						component: ProfessionalAdvertisement,
						title: <IntlTranslation intlkey="professional" />,
						authority: [ADVERTISING_PROFESSIONAL_READ, ADVERTISING_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/advertisement/retail",
						component: RetailAdvertisement,
						title: <IntlTranslation intlkey="retail" />,
						authority: [ADVERTISING_RETAIL_READ, ADVERTISING_RETAIL_WRITE],
					},
				],
			},

			{
				path: "/layout/review",
				icon: <IconFontSider type="icon-check" />,
				title: <IntlTranslation intlkey="review" />,
				isOne: true,
				component: Review,
				isShowRoutes: false,
				isChargeProfessional: true,
				authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE, ADVERTISING_RETAIL_APPROVAL_READ, ADVERTISING_RETAIL_APPROVAL_WRITE],
				routes: [
					{
						path: "/layout/review/unaudited",
						component: Unaudited,
						authority: [ADVERTISING_RETAIL_APPROVAL_READ, ADVERTISING_RETAIL_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="unaudited" />,
					},
					{
						path: "/layout/review/audited",
						component: Audited,
						authority: [ADVERTISING_RETAIL_APPROVAL_READ, ADVERTISING_RETAIL_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="audited" />,
					},
					{
						path: "/layout/review/submitted",
						component: Submitted,
						authority: [ADVERTISING_RETAIL_APPROVAL_READ, ADVERTISING_RETAIL_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="submitted" />,
					},
				],
			},
			// {
			// 	path: "/layout/tags",
			// 	component: Tags,
			// 	isChargeProfessional: true,
			// 	isOne: true,
			// 	isShowRoutes: false,
			// 	icon: <IconFont type="icon-tags" />,
			// 	title: <IntlTranslation intlkey="tags" />,
			// 	authority: [TAG_READ, TAG_WRITE, TAG_PROFESSIONAL_WRITE, TAG_PROFESSIONAL_READ],
			// 	routes: [
			// 		{
			// 			path: "/layout/tags/professional",
			// 			component: TagsProfessional,
			// 			title: <IntlTranslation intlkey="professional" />,
			// 			authority: [TAG_PROFESSIONAL_READ, TAG_PROFESSIONAL_WRITE],
			// 		},
			// 		{
			// 			path: "/layout/tags/retail",
			// 			component: TagsRetail,
			// 			title: <IntlTranslation intlkey="retail" />,
			// 			authority: [TAG_READ, TAG_WRITE],
			// 		},
			// 	],
			// },

			{
				path: "/layout/system/role",
				component: Role,
				title: <IntlTranslation intlkey="role" />,
				authority: [ROLE_READ, ROLE_WRITE],
			},
			{
				path: "/layout/system/user",
				component: User,
				title: <IntlTranslation intlkey="user" />,
				authority: [USER_READ, USER_WRITE],
			},
			{
				path: "/layout/system/authority",
				component: Authority,
				title: <IntlTranslation intlkey="authority" />,
				authority: [AUTHORITY_READ, AUTHORITY_WRITE],
			},
			// {
			// 	path: "/layout/customers",
			// 	component: Customers,
			// 	icon: <IconFont type="icon-customer" />,
			// 	title: <IntlTranslation intlkey="customers" />,
			// 	authority: [CUSTOMERS_PROFESSIONAL_READ, CUSTOMERS_PROFESSIONAL_WRITE],
			// 	isOne: true,
			// 	isChargeProfessional: true,
			// 	isShowRoutes: false,
			// },
			{
				path: "/layout/system",
				icon: <IconFontSider type="icon-system" />,
				title: '系统设置',
				isOne: true,
				isShowRoutes: true,
				authority: [USER_READ, USER_WRITE, ROLE_READ, ROLE_WRITE, AUTHORITY_READ, AUTHORITY_WRITE],
				routes: [
					{
						path: "/layout/system/user",
						component: User,
						title: <IntlTranslation intlkey="user" />,
						authority: [USER_READ, USER_WRITE],
					},
					{
						path: "/layout/system/role",
						component: Role,
						title: <IntlTranslation intlkey="role" />,
						authority: [ROLE_READ, ROLE_WRITE],
					},
					{
						path: "/layout/system/authority",
						component: Authority,
						title: <IntlTranslation intlkey="authority" />,
						authority: [AUTHORITY_READ, AUTHORITY_WRITE],
					},
				],
			},

		],
	},
	{
		path: "/404",
		component: NotFound,
		title: "404",
	},
	{
		path: null,
		redirect: "/404",
	},
];

export default routes;
